<template>
  <v-expansion-panel>
    <v-expansion-panel-content v-for="(faq,i) in faqs" :key="i">
      <div slot="header">{{faq.title}}</div>
      <v-card>
        <v-card-text>{{faq.text}}</v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'Help',
  props: ['auth', 'authenticated'],
  data() {
    return {
      faqs: [
        {
          title: 'How to search for exact phrases',
          text:
            'You can also search for exact phrases by wrapping them in double-quotes. For example, the following will find all documents containing "Ultrasonic Parameter Mismatch" or “Command Failed” '
        },
        {
          title: 'How to exclude terms in search',
          text:
            'To exclude a word, you can prepend a “-” character. For example, to find all stores containing "Ultrasonic Parameter Mismatch" but not include “IQ037ST036”:  "Ultrasonic Parameter Mismatch" -IQ037ST036'
        },
        {
          title: 'Can I search both subject and body of alert emails?',
          text:
            'Yes, The search bar looks for your phrase in both subject and body.'
        }
      ]
    };
  },
  computed: {
    test() {
      console.log(this.auth);
      return true;
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Help.vue